// SearchButton — the header trigger for the site's command palette.
// Desktop: a bordered mono chip (the JourneyBadge's old seat and styling);
// ≤960px the chip text hides and the magnifying glass carries it alone.
// Opening is event-bus based (one palette instance lives in App), and
// hovering or focusing the trigger prefetches the index chunk so the first
// keystroke after open is instant.

import { prefetchSearchIndex } from "../lib/search-loader";

export const SEARCH_OPEN_EVENT = "ktp:search-open";

export function openSearch() {
  window.dispatchEvent(new CustomEvent(SEARCH_OPEN_EVENT));
}

const IS_MAC =
  typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

export default function SearchButton() {
  return (
    <button
      type="button"
      onClick={openSearch}
      onMouseEnter={() => { void prefetchSearchIndex().catch(() => undefined); }}
      onFocus={() => { void prefetchSearchIndex().catch(() => undefined); }}
      // Named by its own text ("search ⌘K"): an aria-label that differs from the visible words fails
      // label-content-name-mismatch, and on small screens the words are still read, only hidden from view.
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "4px 10px",
        minWidth: 44,
        minHeight: 44,
        border: "1px solid var(--line)",
        background: "var(--panel)",
        fontFamily: "var(--mono)",
        fontSize: 10,
        letterSpacing: 0.5,
        textTransform: "uppercase",
        color: "var(--ink-2)",
        cursor: "pointer",
        transition: "border-color 150ms var(--ease-out-soft)",
      }}
      onMouseOver={(e) => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--accent)";
      }}
      onMouseOut={(e) => {
        (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--line)";
      }}
    >
      <span aria-hidden style={{ fontSize: 13, lineHeight: 1 }}>
        ⌕
      </span>
      <span className="search-chip-text">search</span>
      <span className="search-chip-text" style={{ color: "var(--ink-3)" }}>
        {IS_MAC ? "⌘K" : "ctrl K"}
      </span>
    </button>
  );
}
